import { useState } from "react";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import {
  ExplainerType,
  SkinMatchIngredientData,
} from "@/hooks/useSkinMatch/skinMatchSchema";
import styles from "./IngredientDetail.module.scss";
import { sendEvent } from "@JohnLewisPartnership/experiments-utils";

type Props = {
  data: SkinMatchIngredientData;
};

export const IngredientDetail = ({ data }: Props) => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const [inciName, setInciName] = useState<string>("");
  const [ingredientDetail, setIngredientDetail] = useState<ExplainerType>();

  const handleClose = () => {
    setDrawerIsOpen(false);
  };
  return (
    <div
      data-testid="ingredient:detail"
      className={styles.skinMatchApi}
      data-component="Ingredients"
    >
      <p className={styles.helperText}>
        Click on an ingredient to see its source, uses and effects. All
        ingredients are listed in descending order by weight.
      </p>
      <div className={styles.ingredientLists}>
        {data.map(({ inci_name, inci_id, explainer }) => {
          const inciName = inci_name.toLocaleLowerCase();
          return (
            <div
              role="listItem"
              className={styles.ingredientList}
              key={inci_id}
              tabIndex={0}
              data-text={inciName}
              onClick={() => {
                setInciName(inciName);
                setIngredientDetail(explainer);
                setDrawerIsOpen(true);
                sendEvent("ingredients_content_listItem_click");
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setInciName(inciName);
                  setIngredientDetail(explainer);
                  setDrawerIsOpen(true);
                  sendEvent("ingredients_content_listItem_click");
                }
              }}
            >
              {inciName}
            </div>
          );
        })}
      </div>
      <div className={styles.disclaimer}>
        <div className={styles.disclaimerTitle}>Disclaimer:</div>
        The ingredients list and details are provided by Skin Match Technology
        for information purposes only. Formulation and ingredients are subject
        to change by the brand. Please refer to the product packaging for the
        most up-to-date ingredients list and be aware that it may change or vary
        from time to time. For any concerns please seek professional advice
        before use.
      </div>
      <Drawer heading="Ingredients" isOpen={drawerIsOpen} onClose={handleClose}>
        <h3 className={styles.detailTitle}>
          More about <span>{inciName}</span>
        </h3>
        <ul className={styles.detailList}>
          {ingredientDetail &&
            Object.entries(ingredientDetail).map(([key, value]) => {
              return value.map((v, i) => (
                <li className={styles.detailListItem} key={key + i}>
                  {v}
                </li>
              ));
            })}
        </ul>
        <p className={styles.poweredBy}>Powered by Skin Match Technology</p>
      </Drawer>
    </div>
  );
};
